import { PRINT_EVENT_LABEL_NOT_IN_JOB } from '@/shared/utils/printJobIds';

/** Decode miss from WebcamCaptureQR when the shutter finds no QR in frame. */
export const QR_NOT_DETECTED_MESSAGE = 'No QR code detected. Please try again.';

/** Parsed QR with no storage ID — order detail, bundle work, batch orders. */
export const QR_NOT_FOUND_RETRY_MESSAGE = 'QR code not found. Please try again.';

/** Parsed QR with no storage ID — Check Label Out, Reprint. */
export const QR_NOT_FOUND_MESSAGE = 'QR code not found.';

/** Parsed QR with no storage ID — Scan Label, Search Warehouse. */
export const QR_UNREADABLE_STORAGE_ID_MESSAGE = 'Could not read a storage ID from that QR code.';

/** Hold + fade length. Keep in sync with `webcam-qr-miss-fade` in WebcamCapture.css. */
export const QR_MISS_FADE_MS = 4000;

export function isFadingQrScanError(message: string): boolean {
  return (
    message === QR_NOT_DETECTED_MESSAGE ||
    message === QR_NOT_FOUND_RETRY_MESSAGE ||
    message === QR_NOT_FOUND_MESSAGE ||
    message === QR_UNREADABLE_STORAGE_ID_MESSAGE ||
    message === PRINT_EVENT_LABEL_NOT_IN_JOB
  );
}
